import { createFileRoute, redirect } from "@tanstack/react-router";

import { AuthenticatedRouteOutlet } from "src/components/AuthenticatedRouteOutlet";
import { loaderHandler } from "src/lib/loaderHandler";

export const Route = createFileRoute("/_auth")({
  component: AuthenticatedRouteOutlet,
  ssr: true,
  loader() {
    return loaderHandler((ctx) => {
      if (!ctx.session?.user) {
        throw redirect({
          to: "/",
        });
      }
    });
  },
});
